window.LoopI18n = {
  /**
   * Get current country code
   */
  getCurrentCountry() {
    return window.Shopify?.country || "PT"; // Default to PT
  },

  /**
   * Get translation for a key
   * @param {string} key - Translation key (e.g., 'dogs.yourDogs' or 'wallet.title')
   * @param {string|number} ...args - Values for string interpolation
   */
  t(key, ...args) {
    const country = this.getCurrentCountry();
    const translations =
      window.LoopTranslations[country] || window.LoopTranslations.PT;

    // Navigate through nested object using dot notation
    const value = key
      .split(".")
      .reduce((obj, prop) => obj?.[prop], translations);

    // Note: an empty string is a valid translation (e.g. locales with no
    // gendered article before a name), so only treat null/undefined as missing.
    if (value === null || value === undefined) {
      console.warn(`Translation missing for key: ${key} (country: ${country})`);
      return key; // Return the key itself as fallback
    }

    // Handle string interpolation
    if (args.length > 0) {
      return this.interpolate(value, ...args);
    }

    return value;
  },

  /**
   * Interpolate values into string
   * Supports %s (string) and %d (number) placeholders
   */
  interpolate(str, ...args) {
    let argIndex = 0;
    return str.replace(/%[sd]/g, (match) => {
      if (argIndex < args.length) {
        const value = args[argIndex++];
        return match === "%d" ? Number(value) : String(value);
      }
      return match;
    });
  },

  /**
   * Get all translations for current country
   */
  getTranslations() {
    const country = this.getCurrentCountry();
    return window.LoopTranslations[country] || window.LoopTranslations.PT;
  },
};

// Create shorthand alias
window.t = window.LoopI18n.t.bind(window.LoopI18n);
